import ActionType from 'actions/ActionType'

export default (
  state = {
    dialogOpen: false,
    company_logo_url_blackonwhite: '',
    company_logo_url_color: '',
    company_logo_url_whiteonblack: '',
  },
  action,
) => {
  switch (action.type) {
    case ActionType.LogoManagement.TOGGLE_DIALOG:
      if (typeof action.payload === 'boolean') {
        return {
          ...state,
          dialogOpen: action.payload,
        }
      }

      return {
        ...state,
        dialogOpen: !state.dialogOpen,
      }
    case ActionType.LogoManagement.CHANGE_LOGO_URL:
      return {
        ...state,
        [action.payload?.name]: action.payload?.value,
      }
    case ActionType.Data.READ_SUCCESS:
      if (action.entityType === 'account/preference') {
        return {
          ...state,
          company_logo_url_blackonwhite:
            action.payload?.preferences?.company_logo_url_blackonwhite ||
            state.company_logo_url_blackonwhite,
          company_logo_url_color:
            action.payload?.preferences?.company_logo_url_color ||
            state.company_logo_url_color,
          company_logo_url_whiteonblack:
            action.payload?.preferences?.company_logo_url_whiteonblack ||
            state.company_logo_url_whiteonblack,
        }
      }
      return state
    default:
      return state
  }
}
